import { connect } from "react-redux";
import HeadIncentiveLists from "./headIncentiveLists";
import { bindActionCreators } from "redux";
import { getUserSeniorIncentiveSum,uploadIncentiveUtrFile } from "services/redux/salesIncentive/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    fullHeadIncentiveList: state.SalesIncentiveReducer.getUserSeniorIncentives,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getUserSeniorIncentiveSum,
    documentUploadUrlPublic,
    uploadIncentiveUtrFile,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HeadIncentiveLists);
